import { render, staticRenderFns } from "./UpdateJobType.vue?vue&type=template&id=ac2d124e&scoped=true&"
import script from "./UpdateJobType.vue?vue&type=script&lang=js&"
export * from "./UpdateJobType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2d124e",
  null
  
)

export default component.exports